<template>
  <a-layout id="components-layout-side">
    <a-layout-header class="header" theme="light">
      <Header />
    </a-layout-header>
    <a-layout-content class="layout-content">
      <!-- 内容 -->
      <div class="wrap">
        <div class="main">
          <router-view />
        </div>
      </div>
    </a-layout-content>
    <a-layout-footer>
      <Footer />
    </a-layout-footer>
  </a-layout>
</template>
<script>
import Header from '@/layouts/components/Header';
import Footer from '@/layouts/components/Footer';
export default {
  components: { Header, Footer },
  data() {
    return {
      collapsed: false
    };
  }
};
</script>

<style lang="less">
#components-layout-side {
  min-height: 100vh;
  .ant-layout-header {
    padding: 0 4px;
    background-color: #fff;
  }
}
</style>

<style lang="less" scoped>
.header {
  height: 48px;
}
.layout-content {
  padding: 16px;
  height: calc(100vh - 50px);
  background: rgb(255, 255, 255);
  overflow-y: auto;
}
.wrap {
  height: 100%;
}

.main {
  padding-bottom: 12px;
}
/deep/.ant-layout-footer {
  padding: 0;
}
</style>
